// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchExamples-cls1_Glh","cls2":"ResearchExamples-cls2_cpD ResearchExamples-cls1_Glh"};